{
  "instances": {
    "details": {
      "label": "상세",
      "cache": {
        "hit_ratio": "히트율",
        "hits": "히트",
        "misses": "미스",
        "size": "사이즈"
      },
      "datasource": {
        "active_connections": "활성 커넥션",
        "min_connections": "최소 커넥션",
        "max_connections": "최대 커넥션",
        "title": "데이터소스: {dataSource}",
        "unlimited": "무제한"
      },
      "gc": {
        "count": "횟수",
        "time_spent_max": "최대 소요 시간",
        "time_spent_total": "전체 소요 시간",
        "title": "가비지 컬렉션"
      },
      "health": {
        "title": "상태",
        "toggle_details": "{name} 상태 세부정보 토글"
      },
      "health_group": {
        "title": "상태 그룹"
      },
      "info": {
        "no_info_provided": "정보가 제공되지 않습니다.",
        "title": "정보"
      },
      "memory": {
        "max": "최대",
        "metaspace": "메타스페이스",
        "size": "사이즈",
        "title": "메모리",
        "used": "사용됨",
        "committed": "커밋됨"
      },
      "metadata": {
        "no_data_provided": "메타데이터가 제공되지 않습니다.",
        "title": "메타데이터"
      },
      "process": {
        "cpus": "CPU",
        "pid": "PID",
        "parent_pid": "부모 PID",
        "owner": "소유자",
        "process_cpu_usage": "프로세스 CPU 사용량",
        "system_cpu_usage": "시스템 CPU 사용량",
        "title": "프로세스",
        "uptime": "가동시간"
      },
      "threads": {
        "daemon": "데몬",
        "live": "활성",
        "peak_live": "최대 활성",
        "title": "스레드"
      }
    }
  }
}
